import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *新增资料
 * 
*/

export const compile = params => Http.post(`${baseUrl}/python/tools`, params )
